import styled from '@emotion/styled'

import { colors, palette, Strong, Text } from 'main/ui'

interface IProps {
  active: boolean
}

export const Container = styled.div<IProps>`
  align-items: center;
  background-color: ${({ active }) => (active ? palette.skyBlue2 : palette.white)};
  border: ${({ active }) => (active ? 'none' : `1px solid ${colors.border.default}`)};
  border-radius: 3px;
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  height: 75px;
  justify-content: center;
  width: 75px;
`

export const DayOfWeekLabel = styled(Strong)<IProps>`
  color: ${({ active }) => (active ? palette.white : palette.mediumGray)};
  font-size: 12px;
  line-height: 16px;
  text-transform: uppercase;
`

export const MonthLabel = styled(Text)<IProps>`
  color: ${({ active }) => (active ? palette.white : palette.slate)};
  font-size: 13px;
  line-height: 20px;
`
export const DayLabel = styled(Strong)<IProps>`
  color: ${({ active }) => (active ? palette.white : palette.almostBlack)};
  font-size: 24px;
  line-height: 24px;
  text-transform: uppercase;
`
